import React from "react";
import styled from "styled-components/macro";

const unitStepDic = {
  unit: 0,
  ride: 1,
};

const UnitStepButtons = ({ unitStep, setUnitStep }) => {
  return (
    <Wrapper>
      <Button
        isActive={unitStep === unitStepDic.unit}
        onClick={() => setUnitStep(unitStepDic.unit)}
      >
        Smart Store
      </Button>
      |
      <Button
        isActive={unitStep === unitStepDic.ride}
        onClick={() => setUnitStep(unitStepDic.ride)}
      >
        Ride station
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  height: 59px;
  box-shadow: -3px -3px 4px 0 rgba(0, 0, 0, 0.09);
  border: solid 1px #dcdcdc;
  background-color: #ffffff;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  width: fit-content;
  align-items: center;
`;

const Button = styled.div`
  cursor: pointer;
  padding: 14px 28px;
  color: #4b4b4b;
  font-size: 20px;
  text-decoration: ${({ isActive }) => (isActive ? "underline" : "none")};
  opacity: ${({ isActive }) => (isActive ? 1 : 0.35)};
  transition: all 150ms ease-in-out;
`;

export { UnitStepButtons };
